<template>
  <div class="home">
    <Nav />
    <div class="banner-img">
      <img src="../assets/03.png" width="100%"/>
    </div>
    <div class="main">
      <div class="pro-info">
        <div>
          <h3>产品描述</h3>
          <div class="mt25">以伙伴在金蝶ICRM账户内的数据为依据，分析伙伴经营状况，核额放贷。</div>
        </div>
        <div>
          <h3>申贷条件</h3>
          <div class="mt25">加盟金蝶满1年</div>
          <div>经营状况良好</div>
          <div>信用记录良好</div>
        </div>
        <div>
          <h3>申贷流程</h3>
          <div class="mt25">手机端或网页注册、登陆--录入贷款金额、期限等申贷信息--录入企业基本信息--上传所需资料照片或扫描件--合同签约、贷款审批--放款。</div>
        </div>
        <div>
          <h3>所需材料</h3>
          <div class="mt25">营业执照照片或扫描件</div>
          <div>法人身份证正面、反面照片</div>
          <div>法人手持身份证照片</div>
          <div>法人的人行征信报告照片或扫描件（仅信易贷需要）</div>
        </div>
        <div>
          <h3>贷款费用</h3>
          <div class="mt25">快易贷：月息0.65%，年化7.8%</div>
          <div>信易贷：月息0.9%，年化10.8%</div>
        </div>
        <div>
          <h3>还款方式和计息方式</h3>
          <div class="mt25">等本等息；按月还款。</div>
        </div>
        <div>
          <h3>逾期处理方式</h3>
          <div class="mt25">逾期罚息：每日收取贷款本金的万分之五。</div>
          <div>催收工本费：500元/笔（逾期本息超过1万元）；200元/笔（逾期本息不超过1万元）</div>
        </div>
        <div>
          <h3>业务投诉电话</h3>
          <div class="mt25">0755-86072588</div>
        </div>
      </div>
      <Foot class="mt100"/>
    </div>
  </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {
  },
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home{
    .banner-img{
      img{
        //height: 490px;
      }
    }
    .main{
      height:729px;
      padding-bottom: 100px;
      .pro-info{
        position: relative;
        margin-left: 25%;
        .black-bl{
          position: absolute;
          top: -17px;
          color: rgba(51,47,43,1);
          font-weight: 500;
          font-size: 26px;
        }
        div{
          font-size:13px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(142,142,142,1);
          line-height:26px;
        }
        .mt25{
          margin-top: 25px;
        }
        h3{
          padding-top: 70px;
          font-size:20px;
          color:rgba(51,47,43,1);
        }
        .mt40{
          margin-top: 40px;
        }
        .ml60{
          margin-left: 3.125%;
        }
      }
    }

  }

</style>
